import * as React from 'react';
import { SVGProps } from 'react';

const IconDocFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 5.414a1.5 1.5 0 0 0-.44-1.06L9.647.439A1.5 1.5 0 0 0 8.586 0H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5.414zM12.793 5H9.5a.5.5 0 0 1-.5-.5V1.207L12.793 5zM11 9H4V8h7v1zm-7 3h5v-1H4v1z"
    />
  </svg>
);
export default IconDocFilledSizeS;
